<template>
  <div class="mt-10">

    <div v-if="records.length > 0">
      <h1 class="mt-8 text-center text-2xl lg:text-3xl font-semibold">
        Event Planners near by
      </h1>

      <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 text-center">
        <div
          v-for="ep in records"
          :key="ep.id"
          class="bg-white rounded-lg shadow-card  self-start p-6 md:p-8 m-0 my-8 sm:mx-2 md:my-4"
        >
          <div class="mb-3">
            <img
              class="w-full h-48 md:h-32 object-cover"
              :src="
                ep.logo
                  ? ep.logo
                  : require('@/assets/images/image_unavailable.png')
              "
              :alt="ep.name"
            />
          </div>
          <h1 class="mb-3 font-semibold text-xl">
            {{ ep.name }}
          </h1>
          <p v-if="ep.description" class="text-gray-600 text-sm min-h-6">
            {{ ep.description | truncate(100, "...") }}
          </p>
          <button
            class="btn btn-primary font-semibold rounded px-10 w-full sm:w-auto sm:flex-none mt-5"
            @click.stop="loadMenu(ep.id)"
          >
            Show Products and Services
          </button>
        </div>
      </div>
    </div>

    <slot v-if="notFound" name="notFoundTemplate">
      <div class="p-3 sm:p-5">
          <h1 class="font-semibold mb-6 text-center text-2xl lg:text-3xl">
            There are no event planners or suppliers at this location in the BuildaBox.co directory at this time. Search nearby locations or select an option below.
          </h1>
          
          <button
            class="btn btn-primary font-semibold rounded px-10 w-full sm:w-40 mx-auto block"
            @click="$emit('cancel')"
          >
            <span>Cancel</span>
          </button>
      </div>
    </slot>

    <Modal v-if="showMenuModal">
      <div slot="body">
        <div>
          <h1
            class="font-semibold text-2xl lg:text-3xl text-center mb-8"
            v-if="pickedEP.name"
          >
            {{ pickedEP.name }} Products and Services preview
          </h1>
          <section class="mt-5" style="min-height: 100px">
            <div v-if="loading">
              <Spinner class="mx-auto" orange />
            </div>
            <div v-else>
              <div
                v-for="category in categories"
                :key="category.id"
                class="mb-12"
              >
                <header class="mb-8 flex justify-between items-center">
                  <div>
                    <h1
                      class="text-xl lg:text-2xl text-primary font-extrabold text-left py-2"
                    >
                      {{ category.name }}
                    </h1>
                    <p class="text-sm opacity-75">
                      {{ category.description }}
                    </p>
                  </div>
                </header>
                <div>
                  <div v-for="item in category.items" :key="item.id">
                    <div class="mb-6">
                      <div
                        class="flex items-center justify-between md:items-start"
                      >
                        <div
                          class="w-20 h-20 rounded overflow-hidden flex items-center justify-center flex-shrink-0"
                        >
                          <img
                            v-if="item.image"
                            :src="item.image"
                            alt="BuildaBox Order Process"
                          />
                        </div>
                        <div class="mx-5 flex-grow hidden md:block">
                          <div class="font-base font-semibold mb-1">
                            {{ item.name }}
                          </div>
                          <div class="text-sm opacity-75">
                            {{ item.description }}
                          </div>
                        </div>
                      </div>
                      <div class="md:hidden py-5">
                        <div class="font-base font-semibold mb-1">
                          {{ item.name }}
                        </div>
                        <div class="text-sm opacity-75">
                          {{ item.description }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="mt-20">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                @click="showMenuModal = false"
              >
                <span>Cancel</span>
              </button>
              <button
                class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                @click="submitEP"
              >
                <Spinner v-if="loading" class="mx-auto" />
                <span v-else>Select Business</span>
              </button>
            </div>
          </section>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import Spinner from "@/components/common/Spinner";
import ApiV1 from "@/api/api_v1.0";
import Modal from "@/components/common/Modal";

export default {
  name: "OrderSearchEventPlanners",

  components: {
    Spinner,
    Modal
  },

  props: ["zip"],

  data() {
    return {
      loading: false,
      records: [],
      categories: [],
      pickedEPId: null,
      showMenuModal: false,
      notFound: false,
    };
  },

 

  mounted() {
    if (this.zip && this.zip.length > 0) {
      this.submitLocation();
    }
  },

  watch: {
    zip: function(oldValue, newValue) {
      this.submitLocation();
    }
  },

  methods: {

    submitLocation() {
      this.loading = true;
      this.notFound = false;

      ApiV1.getEventPlannersByLocation(this.zip)
        .then(res => {
          this.records = res.data;

          if (this.records.length === 0) {
            this.notFound = true;
            this.$emit('locationNotFound', this.zip);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    loadMenu(ep_id) {
      this.pickedEPId = ep_id;
      this.loading = true;
      ApiV1.getEventPlannerCategories(ep_id)
        .then(response => {
          this.categories = response.data;
          this.showMenuModal = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    submitEP() {
      this.showMenuModal = false;
      this.$emit("select", { zip: this.zip, id: this.pickedEPId });
    }
  },

  computed: {
    pickedEP() {
      return this.pickedEPId
        ? this.records.find(ep => ep.id === this.pickedEPId)
        : null;
    }
  },

  filters: {
    truncate: function(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    }
  }
};
</script>

<style scoped></style>
